// Persistence layer public surface. Phase 3 Step 5 (2/4).

export { openDb, deleteDb, DB_NAME, DB_VERSION } from './db.js';
export type { RenavoraDb, RenavoraSchema } from './db.js';

export {
  SCHEMA_VERSION,
  newDefaultCharacter,
  saveCharacter,
  loadCharacter,
  listCharacters,
  deleteCharacter,
  hydrateRecord,
} from './character.js';
export type { SerializableCharacter, SerializedCharacter } from './character.js';

export {
  readLastActiveId,
  writeLastActiveId,
  clearLastActiveId,
} from './last-active.js';
